import React, { useState, useRef, useEffect } from "react";

const CustomDropdown = ({
  placeholder = "Select",
  disabled = false,
  value = "",
  onChange,
  children,
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // SAFELY convert <option> children into usable array
  const optionElements = React.Children.toArray(children).filter(Boolean);

  const options = optionElements.map((child) => ({
    label: child.props?.children ?? "",
    value: child.props?.value ?? "",
  }));

  const selected = options.find((o) => o.value === value);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    const syntheticEvent = {
      target: { value: option.value },
      stopPropagation: () => { },
      preventDefault: () => { },
    };

    onChange(syntheticEvent);
    setOpen(false);
  };

  return (
    <div ref={dropdownRef} className={`relative w-full ${className}`}>
      {/* Trigger */}
      <div
        className={`
          border border-gray-400 rounded-sm px-3 py-2 bg-white
          flex justify-between items-center
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        `}
        onClick={() => !disabled && setOpen(!open)}
      >
        <span>{selected ? selected.label : placeholder}</span>
        <span>▾</span>
      </div>

      {/* Dropdown List */}
      {open && (
        <div className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-md z-50 max-h-60 overflow-auto">
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`
                px-3 py-2 cursor-pointer
                ${opt.value === value ? "bg-blue-100 font-semibold" : "hover:bg-gray-100"}
              `}
              onClick={() => handleSelect(opt)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
